module.exports = __webpack_public_path__ + "img/bacon_premium.0e2b32fc.jpeg";